import { useState } from 'react';
import PropTypes from 'prop-types';
import { Chip, Tooltip } from '@mui/material';

LabelWithDescriptionComponent.propTypes = {
  categories: PropTypes.string.isRequired,
  categoriesSlugInfo: PropTypes.string.isRequired,
  size: PropTypes.string,
};

LabelWithDescriptionComponent.defaultProps = {
  size: 'small',
};

export default function LabelWithDescriptionComponent({
  categories,
  categoriesSlugInfo,
  size,
}) {
  const [openCategoryInfo, setOpenCategoryInfo] = useState(false);
  const handleOpenCategory = () => setOpenCategoryInfo(!openCategoryInfo);

  return (
    <Tooltip
      onClose={handleOpenCategory}
      open={openCategoryInfo}
      title={categoriesSlugInfo}
    >
      <Chip
        sx={{
          backgroundColor: '#F07C17',
          color: 'white',
          px: 2,
          '&:hover': {
            backgroundColor: '#F07C17',
          },
        }}
        label={categories}
        onClick={handleOpenCategory}
        size={size}
      />
    </Tooltip>
  );
}
